import * as React from 'react'

import FooterContainer from '../sections/FooterContainer/FooterContainer'
import HeaderSection from '../sections/HeaderSection/HeaderSection'
// import TopBanner from '../sections/TopBanner/TopBanner'

const Layout = ({ children, pageContext }) => {
  return (
    <main id="body">
      {/* <TopBanner lang={pageContext.lang.slice(0, 2)} /> */}
      <HeaderSection pageContext={pageContext} />
      {children}
      <FooterContainer pageContext={pageContext} />
    </main>
  )
}

export default Layout
